import {
  EpisodeOfCareRelatedConditionschema,
  LinkedConditionInformation,
} from "@/modules/patients/detail/episode-of-care/components/related-conditions-form"
import { IcdDiagnosisFragment$data } from "@/modules/patients/services/__generated__/IcdDiagnosisFragment.graphql"

export const handleAppendRelatedConditions = (
  option: IcdDiagnosisFragment$data,
  relatedConditions: EpisodeOfCareRelatedConditionschema["relatedConditions"],
  setLinkedConditionInformation: (value: LinkedConditionInformation | undefined) => void,
  appendRelatedCondition: (value: EpisodeOfCareRelatedConditionschema["relatedConditions"][number]) => void,
) => {
  if (
    option.linkedConditionIcdDiagnosis?.diagnosisCode &&
    relatedConditions.every((r) => r.icdCode !== option.linkedConditionIcdDiagnosis?.diagnosisCode)
  ) {
    appendRelatedCondition({
      icdCode: option.linkedConditionIcdDiagnosis.diagnosisCode,
      description: option.linkedConditionIcdDiagnosis.text,
      value: false,
      isFromIcdSelectInThisSession: true,
    })

    setLinkedConditionInformation({
      diagnosisCode: option.linkedConditionIcdDiagnosis.diagnosisCode,
      text: option.linkedConditionIcdDiagnosis.text,
    })
  } else if (
    option.linkedConditionIcdDiagnosis?.diagnosisCode &&
    relatedConditions.some((r) => r.icdCode === option.linkedConditionIcdDiagnosis?.diagnosisCode)
  ) {
    setLinkedConditionInformation({
      diagnosisCode: option.linkedConditionIcdDiagnosis.diagnosisCode,
      text: option.linkedConditionIcdDiagnosis.text,
    })
  } else {
    setLinkedConditionInformation(undefined)
  }
}
